import { authedFetch } from '@/lib/authed-fetch';
import type { Database } from '@sixam/shared/database.types';

export type TenantMemberRole = Database['public']['Enums']['tenant_role'];

export type TenantMemberListItem = Readonly<{
  avatarUrl: string | null;
  fullName: string | null;
  id: string;
  role: TenantMemberRole;
}>;

export async function fetchTenantMembers(tenantSlug: string): Promise<TenantMemberListItem[]> {
  const response = await authedFetch(`/api/admin/${tenantSlug}/members`);
  const payload = (await response.json().catch(() => null)) as {
    error?: string;
    members?: TenantMemberListItem[];
  } | null;

  if (!response.ok) {
    throw new Error(payload?.error ?? 'Could not load tenant members.');
  }

  return payload?.members ?? [];
}
